/* tslint:disable */
/* eslint-disable */
/**
 * Protected Bricks API
 * API für die Verwaltung und Analyse von Klemmbaustein-Sets auf Design-Schutzrechte
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@protectedbricks.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  SetPageable,
} from '../models/index';
import {
    SetPageableFromJSON,
    SetPageableToJSON,
} from '../models/index';

export interface GetManufacturersRequest {
    page?: number;
    limit?: number;
    manufacturer?: string;
    status?: GetManufacturersStatusEnum;
    search?: string;
}

/**
 * 
 */
export class ManufacturersApi extends runtime.BaseAPI {

    /**
     * Gibt alle analysierten Sets paginiert zurück, mit Hersteller-Informationen
     * Liste aller Sets (paginiert)
     */
    async getManufacturersRaw(requestParameters: GetManufacturersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SetPageable>> {
        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.manufacturer !== undefined) {
            queryParameters['manufacturer'] = requestParameters.manufacturer;
        }

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/manufacturers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SetPageableFromJSON(jsonValue));
    }

    /**
     * Gibt alle analysierten Sets paginiert zurück, mit Hersteller-Informationen
     * Liste aller Sets (paginiert)
     */
    async getManufacturers(requestParameters: GetManufacturersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SetPageable> {
        const response = await this.getManufacturersRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetManufacturersStatusEnum = {
    All: 'all',
    Safe: 'safe',
    Unsafe: 'unsafe',
    UnknownDefaultOpenApi: '11184809'
} as const;
export type GetManufacturersStatusEnum = typeof GetManufacturersStatusEnum[keyof typeof GetManufacturersStatusEnum];
